import * as React from 'react';
import _ from 'lodash';
import { useSignalRData } from './SignalRDataProvider';
// import { SignalRSiteDeviceData } from '../../types/signalr-types';

import { SignalRSite } from '../../types/signalr-types';

type ContextState = SignalRSite | undefined;

const Context = React.createContext<ContextState | undefined>(undefined);

function useSignalRSiteData(): ContextState {
    const contextState = React.useContext(Context);
    if (contextState === null) {
        throw new Error('useSignalRSiteData must be used within a SignalRSiteDataProvider');
    }
    return contextState;
}

const SignalRSiteDataProvider: React.FC<{
    siteId: string;
    locationId?: string;
}> = (props) => {
    const signalRdData = useSignalRData();
    let realTimeSite: SignalRSite | undefined;

    const realTimeLocation = _.find(signalRdData.locations, { locationId: props.locationId });

    if (realTimeLocation === undefined) {
        _.filter(signalRdData.locations, (location) => {
            realTimeSite = _.find(location && location.sites, { siteId: props.siteId });
        });
        //  realTimeSite = realTimeSite && Object.assign({}, realTimeSite);
    } else realTimeSite = _.find(realTimeLocation && realTimeLocation.sites, { siteId: props.siteId });

    //if (realTimeSite) setValue(realTimeSite);
    return <Context.Provider value={realTimeSite}>{props.children}</Context.Provider>;
};

export { SignalRSiteDataProvider, useSignalRSiteData };
